var map = {
	"./ico10.svg": 6354,
	"./ico12(3+3+3+3).svg": 3474,
	"./ico12(4+2+2+2+2).svg": 2509,
	"./ico2.svg": 3837,
	"./ico2a.svg": 5286,
	"./ico3.svg": 3212,
	"./ico3a.svg": 4677,
	"./ico4.svg": 7843,
	"./ico4a.svg": 1016,
	"./ico5.svg": 9906,
	"./ico5a.svg": 6783,
	"./ico6(2+2+2).svg": 6692,
	"./ico6(3+3).svg": 2349,
	"./ico6(4+2).svg": 4435,
	"./ico6a.svg": 8930,
	"./ico7.svg": 6352,
	"./ico7a.svg": 9361,
	"./ico7aa.svg": 2162,
	"./ico8(2+3+3).svg": 8642,
	"./ico8(2i+3+3).svg": 3943,
	"./ico8(4+2+2).svg": 8700,
	"./ico9.svg": 5798,
	"./icopilar.svg": 7513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1979;